import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {ErrorMessage, Field, useFormikContext} from 'formik'
import {ICreateAccount, inits as initialValues} from '../CreateAccountWizardHelper'
import {useNavigate} from 'react-router-dom'

const Step2: any = ({errors, setActiveStep}: any) => {
  const history = useNavigate()
  const {setFieldValue, setFieldTouched} = useFormikContext<ICreateAccount>()
  const data = initialValues
  const [isInvestor, setIsInvestor] = useState(data.investors)
  const [haveReadConsent, setHaveReadConsent] = useState(false)

  const handleBackRule = () => {
    history('/auth')
  }
  const handleCheckedInvestor = (e: any) => {
    setIsInvestor(e.target.value)
  }

  useEffect(() => {
    if (!errors?.personalEmail && !errors?.phoneNumber && !errors?.occupation && haveReadConsent) {
      setActiveStep(false)
    } else {
      setActiveStep(true)
    }
  }, [
    errors?.personalEmail,
    errors?.phoneNumber,
    errors?.occupation,
    haveReadConsent,
    setActiveStep,
  ])

  return (
    <div className='w-100'>
      <button
        onClick={handleBackRule}
        type='button'
        className='btn btn-lg btn-light-primary back_step2 me-3'
      >
        <KTIcon iconName='arrow-left' className='fs-4 me-1' />
        Quay lại
      </button>
      <div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder text-primary text-center'>Thông tin cá nhân</h2>
      </div>
      <div className='form-text text-danger mb-4' style={{fontStyle: 'italic', marginTop: 0}}>
        Mở tài khoản trực tuyến eKYC chỉ áp dụng cho Khách hàng giao dịch, lưu ký chứng khoán và
        thanh toán tại Chứng khoán NH Việt Nam.
      </div>

      <div className='mb-10 fv-row border p-8 rounded'>
        <label className='form-label '>Quý khách hàng là nhà đầu tư</label>
        <div className='d-flex gap-10 mt-3'>
          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='form-check form-check-custom form-check-solid'>
                <Field
                  className='form-check-input'
                  type='radio'
                  name='investors'
                  checked={isInvestor}
                  value={isInvestor}
                  onClick={handleCheckedInvestor}
                />
              </span>
              <span className='d-flex flex-column mx-4'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>Cá nhân</span>
              </span>
            </span>
          </label>
          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='form-check form-check-custom form-check-solid'>
                <Field
                  className='form-check-input'
                  disabled
                  type='radio'
                  name='investors'
                  value='2'
                />
              </span>
              <span className='d-flex flex-column mx-4'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>Tổ chức</span>
              </span>
            </span>
          </label>
        </div>
        <div
          className='form-text'
          style={{
            // fontFamily: 'Lato',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            lineHeight: '16px',
            marginTop: 0,
            color: '#333',
          }}
        >
          Quý khách là khách hàng Tổ chức, kính mời Quý khách hàng đến trực tiếp Trụ sở/ Chi nhánh
          NHSV để mở tài khoản.
        </div>
      </div>

      <div className='mb-10 fv-row border p-8 rounded'>
        <label className='form-label '>Quốc tịch</label>
        <div className='d-flex gap-10 mt-3'>
          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='form-check form-check-custom form-check-solid'>
                <Field
                  className='form-check-input'
                  type='radio'
                  name='static'
                  checked={'static'}
                  value='vietnam'
                />
              </span>
              <span className='d-flex flex-column mx-4'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>Việt Nam</span>
              </span>
            </span>
          </label>
          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='form-check form-check-custom form-check-solid'>
                <Field
                  className='form-check-input'
                  disabled
                  type='radio'
                  name='static'
                  value='foreign'
                />
              </span>
              <span className='d-flex flex-column mx-4'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>Nước ngoài</span>
              </span>
            </span>
          </label>
        </div>
        <div
          className='form-text'
          style={{
            // fontFamily: 'Lato',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            lineHeight: '16px',
            marginTop: 0,
            color: '#333',
          }}
        >
          You are foreign, please come directly to NHSV Headquarters/Branches to open an account
        </div>
      </div>

      <div className='mb-10 fv-row'>
        <label className='form-label fs-6 fw-bold mb-3 required'>Số điện thoại</label>

        <Field
          type='tel'
          inputMode='numeric'
          placeholder='Nhập số điện thoại'
          className='form-control form-control-lg form-control-solid'
          name='phoneNumber'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFieldValue('phoneNumber', e.target.value.replace(/\D/g, ''))
          }
        />
        <div className='text-danger mt-2'>
          <ErrorMessage component='span' name='phoneNumber' />
        </div>
      </div>

      <div className=' mb-10 fv-row'>
        <label className='fs-6 fw-bold form-label mb-3 required'>Email</label>

        <Field
          name='personalEmail'
          placeholder='Nhập email'
          className='form-control form-control-lg form-control-solid'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage component='span' name='personalEmail' />
        </div>
      </div>

      <div className='fv-row mb-10'>
        <label className='fs-6 fw-bold form-label mb-3'>Mã số thuế</label>

        <Field
          name='tax_cd'
          placeholder='Nhập mã số thuế'
          className='form-control form-control-lg form-control-solid'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage component='span' name='tax_cd' />
        </div>
      </div>

      <div className='fv-row mb-0'>
        <label className='fs-6 fw-bold form-label mb-3 required'>Nghề nghiệp</label>

        <Field
          name='occupation'
          placeholder='Nhập nghề nghiệp'
          className='form-control form-control-lg form-control-solid'
          onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
            setFieldTouched('occupation', true, false)
            setFieldValue('occupation', e.target.value.trim())
          }}
        />
        <div className='text-danger mt-2'>
          <ErrorMessage component='span' name='occupation' />
        </div>
      </div>

      <div
        className='d-flex align-items-start mt-8'
        style={{gap: '8px', cursor: 'pointer'}}
        onClick={() => setHaveReadConsent((prev) => !prev)}
      >
        <input
          type='checkbox'
          checked={haveReadConsent}
          onChange={() => setHaveReadConsent((prev) => !prev)}
          onClick={(e) => e.stopPropagation()}
          style={{
            width: '20px',
            height: '20px',
            flexShrink: 0,
            marginTop: '1px',
            cursor: 'pointer',
          }}
        />
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '18px',
          }}
        >
          Bằng thao tác nhấp chọn vào ô vuông, tôi đã đọc và đồng ý với nội dung &ldquo;
          <a
            href='https://nhsv.vn/uploadfile/source/Thuvientailieu/Bao_ve_va_xu_ly_du_lieu_ca_nhan.pdf'
            target='_blank'
            rel='noreferrer'
            style={{textDecoration: 'underline', color: '#028D96'}}
            onClick={(e) => e.stopPropagation()}
          >
            Điều khoản và điều kiện xử lý dữ liệu cá nhân
          </a>
          &rdquo; của Công ty TNHH Chứng khoán NH Việt Nam
        </span>
      </div>
    </div>
  )
}

export {Step2}
